import { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import { PrivacyPage, TermsPage } from "@/pages/LegalPage";
import PaymentSuccess from "@/pages/PaymentSuccess";

const OwnerDashboard = lazy(() => import("@/pages/OwnerDashboard"));
const InsightsList = lazy(() =>
  import("@/pages/Insights").then((module) => ({ default: module.InsightsList }))
);
const InsightArticle = lazy(() =>
  import("@/pages/Insights").then((module) => ({ default: module.InsightArticle }))
);

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/audit" element={<Home />} />
            <Route path="/pricing" element={<Home />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/owner-dashboard" element={<OwnerDashboard />} />
            <Route path="/seo-dashboard" element={<OwnerDashboard />} />
            <Route path="/insights" element={<InsightsList />} />
            <Route path="/insights/:slug" element={<InsightArticle />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
